import { register } from "@shopify/theme-sections";
import Swiper from "swiper/bundle";

const waitForElm = (selector) => {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver((mutations) => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
};

register("product-recommendations", {
  initSlider() {
    const mayLikeCarousel = this.container.querySelector(".nosto-swiper");
    if (!mayLikeCarousel) return;
    const maylikeswiper = new Swiper(mayLikeCarousel, {
      slidesPerView: 1.3,
      spaceBetween: 10,
      slidesPerGroup: 1,
      pagination: false,
      autoplay: false,
      loop: true,
      navigation: {
        nextEl: ".recommend-list__navigation .swiper-button-next",
        prevEl: ".recommend-list__navigation .swiper-button-prev",
      },
      breakpoints: {
        769: {
          slidesPerView: 5,
          slidesPerGroup: 1,
          spaceBetween: 15,
          allowTouchMove: true,
        },
      },
    });
  },

  onLoad: function (e) {
    if (this.container.querySelector(".recommendations-container"))
      waitForElm(".nosto-swiper").then(() => {
        this.initSlider();
      });
  },
});
